module.exports = "/static/assets/f641a96c9e9840b7eca4df592057d79c.png";